import $ from 'jquery';
import Subscribe from '@shopify/marketing-assets/javascripts/modules/subscribe';
import {setIsSubscribed} from '../utilities/subscription-cookie';

function initializeSubscriptionWithCookie() {
  const $subscriptionForm = $('.js-subscribe-with-cookie');

  $subscriptionForm.each((i, el) => {
    new Subscribe($(el), {
      onSuccess: () => {
        setIsSubscribed(true);
      },
    });
  });
}

export default initializeSubscriptionWithCookie;
